module.exports = __webpack_public_path__ + "img/rs.d583be7e.png";